import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { ButtonVariant, useAuthContext, FormInput } from '@catalyze/ui';
import type { IUserSignInData } from 'api/types/user';
import { Routes } from 'constants/routes';
import { signInFormSchema } from 'schemas/signInForm';

import { StyledForm, StyledButton, ErrorMessage } from './styled';

export const SignInForm = () => {
    const formMethods = useForm<IUserSignInData>({
        resolver: yupResolver(signInFormSchema),
    });

    const { handleSubmit } = formMethods;

    const [hasError, setError] = useState(false);
    const navigate = useNavigate();
    const value = useAuthContext();
    const { handleUserSignIn } = value;

    const onSubmit = async (data: IUserSignInData) => {
        setError(false);

        try {
            await handleUserSignIn(data);
            navigate(Routes.OVERVIEW);
        } catch (err) {
            setError(true);
        }
    };

    return (
        <FormProvider {...formMethods}>
            <StyledForm onSubmit={handleSubmit(onSubmit)}>
                <FormInput label="Email" id="email" />

                <FormInput label="Password" id="password" type="password" />

                {hasError && (
                    <ErrorMessage>
                        We couldn’t sign you in. Please check your credentials
                        and try again.
                    </ErrorMessage>
                )}

                <StyledButton type="submit" variant={ButtonVariant.PRIMARY}>
                    Sign in
                </StyledButton>
            </StyledForm>
        </FormProvider>
    );
};
